import React, { Suspense } from 'react'
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import PublisherUsersList from "../../pages/publisher/users/PublisherUsersList";
import NewPublisherUser from "../../pages/publisher/users/NewPublisherUser";
import PublisherUser from "../../pages/publisher/users/PublisherUser";
import EditPublisherUser from "../../pages/publisher/users/EditPublisherUser";

const Users = () => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route exact path={path} component={PublisherUsersList}/>
        <Route path={`${path}/new`} component={NewPublisherUser}/>
        <Route exact path={`${path}/:userId`} component={PublisherUser}/>
        <Route path={`${path}/:userId/edit`} component={EditPublisherUser}/>
      </Switch>
    </Suspense>

  );
}

export default Users;
